import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import {
  CommonDropdown,
  GetAuctionStep1,
  RegisteredUsers,
} from '../../../models';
import { AuctionService, LoaderService } from '../../../services';
import constants from '../../../utility/constants';
import {
  ImportResultService,
} from '../service/import-result.service';
import {  Subscription } from 'rxjs';
@Component({
  selector: 'app-imported-users',
  templateUrl: './imported-users.component.html',
  styleUrls: ['./imported-users.component.css'],
})
export class ImportedUsersComponent implements OnInit {
  displayedColumns: string[] = [
    'bidderNum',
    'name',
    'company',
    'spendHistory',
    'status',
  ];
  auctionUsers: Array<RegisteredUsers> = [];
  totalCount: number = 0;

  auctionId: number;
  auctionData: GetAuctionStep1;
  auctionsDD: Array<CommonDropdown> = [];

  searchTerm: string = '';
  pageNumber: number = 1;
  pageSize: number = constants.admin.adminPageSize;
  private subscriptions: Array<Subscription> = [];
  constructor(
    private importResult: ImportResultService,
    private router: Router,
    private route: ActivatedRoute,
    private loader: LoaderService,
    private auctionService: AuctionService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((res) => {
      let param = res['id'];
      if (param) {
        if (typeof +param == 'number') {
          this.auctionId = +param;
          this.getAuctionData();
        }
      } else {
        this.goBack();
      }
    });
    this.auctionsForDD();
  }

  auctionsForDD() {
    const iauctions = this.importResult.getAuctionsForDD().subscribe((res) => {
      this.auctionsDD = res;
    });
    this.subscriptions.push(iauctions);
  }

  private getAuctionData() {
    const aucStep1 = this.auctionService.getAuctionStep1(this.auctionId).subscribe((res) => {
      this.auctionData = res;
    });
    this.subscriptions.push(aucStep1);
    this.getAllUsers();
  }

  onAuctionChange(value: number) {
    this.auctionId = value;
    this.getAuctionData();
  }

  changeSearchValue(val: Observable<string>) {
    const vals = val.subscribe((value) => {
      this.searchTerm = value;
      this.pageNumber = 1;
      this.getAllUsers();
    });
    this.subscriptions.push(vals);
  }

  private pagingParams() {
    return {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      isPaginated: true,
      auctionId: this.auctionId,
      searchTerm: this.searchTerm,
    };
  }

  private getAllUsers() {
    this.loader.showLoader(true);
    const rusers = this.auctionService.getRegisteredUsers(this.pagingParams()).subscribe(
      (res) => {
        this.loader.showLoader(false);
        this.auctionUsers = res.data;
        this.totalCount = res.totalCount;
      },
      (_) => {
        this.loader.showLoader(false);
        this.totalCount = 0;
      }
    );
    this.subscriptions.push(rusers);
  }

  onPageChange(page: number) {
    this.pageNumber = page;
    this.getAllUsers();
  }

  goBack() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
